import React from "react";
import { createBrowserRouter, RouterProvider, Outlet, Navigate, createRoutesFromElements, Route } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import AppShell from "@/components/shell/AppShell";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import SuppliersPage from "@/pages/SuppliersPage";
import AdminPage from "@/pages/AdminPage";
import PlanningPage from "@/pages/PlanningPage";
import AuditsListPage from "@/pages/AuditsListPage";
import AuditDetailPage from "@/pages/AuditDetailPage";
import ReviewPage from "@/pages/ReviewPage";
// import CapaPage from "@/pages/CapaPage"; // Temporarily disabled per stakeholder request
import ReportsPage from "@/pages/ReportsPage";
import ReportViewPage from "@/pages/ReportViewPage";
import NotificationsPage from "@/pages/NotificationsPage";
import AuditTrailPage from "@/pages/AuditTrailPage";
import AccountPage from "@/pages/AccountPage";
import FormulaEnginePage from "@/pages/FormulaEnginePage";
import "@/App.css";

function RequireRole({ roles, children }) {
  const { user } = useAuth();
  if (!user) return null;
  if (user.role === "system_admin") return children;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

// Root layout so AuthProvider participates in the data router's context.
function RootLayout() {
  return (
    <AuthProvider>
      <Outlet />
    </AuthProvider>
  );
}

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route element={<RootLayout />}>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<AppShell />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/planning" element={<RequireRole roles={["sd_admin", "manager"]}><PlanningPage /></RequireRole>} />
        <Route path="/audits" element={<AuditsListPage />} />
        <Route path="/audits/:id" element={<AuditDetailPage />} />
        <Route path="/review" element={<RequireRole roles={["manager"]}><ReviewPage /></RequireRole>} />
        <Route path="/suppliers" element={<RequireRole roles={["sd_admin", "manager"]}><SuppliersPage /></RequireRole>} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/reports/:id" element={<ReportViewPage />} />
        <Route path="/admin" element={<RequireRole roles={["system_admin"]}><AdminPage /></RequireRole>} />
        <Route path="/admin/formula-engine" element={<RequireRole roles={["system_admin", "sd_admin"]}><FormulaEnginePage /></RequireRole>} />
        {/* CAPA temporarily disabled */}
        {/* <Route path="/capa" element={<CapaPage />} /> */}
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/audit-trail" element={<RequireRole roles={["manager"]}><AuditTrailPage /></RequireRole>} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Route>
  )
);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
